const actions = {

    FETCH_TEACHER_UNSEEN_EMAILS: 'FETCH_TEACHER_UNSEEN_EMAILS',
    fetchTeacherUnseenEmailsAction: (data) => ({
        type: actions.FETCH_TEACHER_UNSEEN_EMAILS,
        data
    }),

    FETCH_STUDENT_UNSEEN_EMAILS: 'FETCH_STUDENT_UNSEEN_EMAILS',
    fetchStudentUnseenEmailsAction: (data) => ({
        type: actions.FETCH_STUDENT_UNSEEN_EMAILS,
        data
    }),

    FETCH_CLASS_TEACHER_ZOOM_UNSEEN_EMAILS: 'FETCH_CLASS_TEACHER_ZOOM_UNSEEN_EMAILS',
    fetchClassTeacherZoomEmailsAction: (data) => ({
        type: actions.FETCH_CLASS_TEACHER_ZOOM_UNSEEN_EMAILS,
        data
    }),

    FETCH_UNSEEN_COMMENTS: 'FETCH_UNSEEN_COMMENTS',
    fetchUnseenCommentsAction: (data) => ({
        type: actions.FETCH_UNSEEN_COMMENTS,
        data
    }),

    FETCH_UNSEEN_MESSAGES: 'FETCH_UNSEEN_MESSAGES',
    fetchUnseenMessagesAction: (data) => ({
        type: actions.FETCH_UNSEEN_MESSAGES,
        data
    }),

    FETCH_UNSEEN_CV: 'FETCH_UNSEEN_CV',
    fetchUnseenCVsAction: (data) => ({
        type: actions.FETCH_UNSEEN_CV,
        data
    }),

    FETCH_UNSEEN_TALENT_CV: 'FETCH_UNSEEN_TALENT_CV',
    fetchUnseenTalentCVsAction: (data) => ({
        type: actions.FETCH_UNSEEN_TALENT_CV,
        data
    }),

    FETCH_UNSEEN_OFFICIAL_EMAILS: 'FETCH_UNSEEN_OFFICIAL_EMAILS',
    fetchUnseenOfficialEmailsAction: (data) => ({
        type: actions.FETCH_UNSEEN_OFFICIAL_EMAILS,
        data
    }),

    FETCH_UNSEEN_PERMISSION_UPDATE: 'FETCH_UNSEEN_PERMISSION_UPDATE',
    fetchUnseenPermissionUpdateAction: (data) => ({
        type: actions.FETCH_UNSEEN_PERMISSION_UPDATE,
        data
    }),

};

export default actions;
